import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { formatNumberWithSymbols } from "../../../helperJs/helper";
import ChartImage from "../../Assets/home/chart-4.png";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,  
  BarElement,
  Title,
  Tooltip,
  Legend
);
const GroupedBarsChart = ({ data }) => {
  const { t } = useTranslation();

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        interaction: { mode: "index", intersect: false },
        callbacks: {
          label: (context) => {
            const datasetLabel = context.dataset.label || "";
            const value = context.parsed.y;
            return `${datasetLabel}: ${formatNumberWithSymbols(value)}`;
          },
        },
        boxPadding: 5,
        cornerRadius: 1,
        caretSize: 10,
        padding: 10,
        margin: 0,
        boxHeight: 30,
        borderColor: "rgba(0, 0, 0, 0.2)",
        borderWidth: 1,
        borderRadius: 5,
        boxWidth: 10,
        titleColor: "black",
        bodyColor: "black",
        bodyFont: {
          size: 14,
          weight: 500,
          font: "Lato",
        },
        bodySpacing: 7,
        usePointStyle: true,
        backgroundColor: "#FFFFFF",
        titleFont: {
          size: 14,
          weight: 400,
          font: "Lato",
        },
      },
    },
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
        // ticks: {
        //   callback: function (value, index, ticks) {
        //     const datasetCount = this.chart?.data?.datasets?.length || 0;
        //     if (datasetCount > 5) {
        //       return index % 2 === 0 ? this.getLabelForValue(value) : null;
        //     }
        //     return this.getLabelForValue(value);
        //   },
        // },
        stacked: false,
        barPercentage: 1, // Remove the gap between bars
        categoryPercentage: 1, // Remove the gap between bars
      },
      y: {
        grid: {
          borderDash: [8, 4],
          display: true,
        },
        ticks: {
          callback: function (value) {
            const number = formatNumberWithSymbols(value);
            return number;
          },
        },
        stacked: false,
      },
    },
    elements: {
      bar: {
        barThickness: 10, // Set this value to make the bars as thick as available space
      },
    },
  };
  return (
    <div style={{ height: "100%", minWidth: "100%" }}>
      {data?.datasets?.length > 0 ? (
        <Bar options={options} data={data} />
      ) : (
        <>
          <img
            src={ChartImage}
            alt="no-chart"
            className="w-100 h-100 blur-card-wth-btn rounded-4"
          />
          <div className="blur-card-wth-btn">
            <span>{t("common_buttons.no_data")}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default GroupedBarsChart;
